import logoUrl from '../../assets/_logo-smith-white.png';
import content from '../../content/homepage';
import { GhostButton } from '../../components/GhostButton';
import { GoldWord } from '../../components/GoldWord';

export function Hero() {
  const { hero } = content;

  return (
    <section
      id="hero"
      className="relative flex min-h-[80vh] flex-col items-center justify-center px-6 py-[var(--spacing-section-lg)] text-center md:min-h-screen md:px-12 md:py-[var(--spacing-section-xl)]"
    >
      <img
        src={logoUrl}
        alt={hero.logoAlt}
        width={812}
        height={152}
        className="mb-12 h-auto w-full max-w-[420px] md:mb-16 md:max-w-[560px]"
      />

      <h1 className="max-w-[80vw] text-5xl leading-[1.05] font-medium text-[color:var(--color-foreground)] md:text-7xl lg:text-[80px] lg:leading-[96px]">
        {hero.headline.map((segment, index) =>
          segment.accent ? (
            <GoldWord key={index}>{segment.text}</GoldWord>
          ) : (
            <span key={index}>{segment.text}</span>
          ),
        )}
      </h1>

      <p className="font-body mt-8 max-w-2xl text-lg leading-relaxed text-[color:var(--color-foreground)]/80 md:mt-10 md:text-xl">
        {hero.subheadline}
      </p>

      <div className="mt-12 md:mt-14">
        <GhostButton href={hero.cta.href} external>
          {hero.cta.label}
        </GhostButton>
      </div>

      <a
        href="#value"
        aria-label="Read more — scroll to next section"
        className="absolute bottom-6 left-1/2 flex -translate-x-1/2 flex-col items-center gap-2 font-sans text-xs tracking-[var(--tracking-button)] text-[color:var(--color-foreground)]/70 uppercase transition-colors hover:text-[color:var(--color-accent)] md:bottom-10 md:text-sm"
      >
        <span>Read more</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          aria-hidden="true"
          className="h-5 w-5 md:h-6 md:w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
          />
        </svg>
      </a>
    </section>
  );
}
